<div class="date-range-picker">
  <div class="d-flex">
    <!-- Left Menu -->
    <div class="menu-section">
      <div class="menu-list">
        <div class="menu-item" *ngFor="let range of ranges" [class.active]="selectedRangeType === range.value"
          (click)="selectRange(range.value)">
          {{range.label}}
        </div>
      </div>
    </div>

    <!-- Right Calendar -->
    <div class="calendar-section">
      <!-- Date Range Display -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="selected-range p-2 bg-light rounded">{{formatDateRange()}}</div>
        <div class="text-muted small">Last Update Data {{lastUpdateDate | date:'dd/MM/yy'}}</div>
      </div>

      <!-- Calendars -->
      <div class="d-flex gap-4">
        <!-- First Month -->
        <div class="calendar-box">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <button class="btn p-0 text-success nav-btn" (click)="navigateMonth('prev')">
              <i class="fa-solid fa-chevron-left"></i>
              <span class="month-title text-success">{{currentMonth | date:'MMM yyyy'}}</span>
            </button>
            <div class="invisible">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
          </div>

          <div class="calendar-grid">
            <div class="weekday" *ngFor="let day of ['Sa', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']">{{day}}</div>
            <ng-container *ngFor="let week of calendar.current">
              <div *ngFor="let date of week" [class]="getCellClass(date)" (click)="date && onDateClick(date)"
                (mouseenter)="date && onDateHover(date)">
                {{date ? (date | date:'d') : ''}}
              </div>
            </ng-container>
          </div>
        </div>
        <!-- Second Month -->
        <div class="calendar-box">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="invisible">
              <i class="fa-solid fa-chevron-left"></i>
            </div>
            <button class="btn p-0 text-success nav-btn" (click)="navigateMonth('next')">
              <span class="month-title text-success">{{nextMonth | date:'MMM yyyy'}}</span>
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          </div>

          <div class="calendar-grid">
            <div class="weekday" *ngFor="let day of ['Sa', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']">{{day}}</div>
            <ng-container *ngFor="let week of calendar.next">
              <div *ngFor="let date of week" [class]="getCellClass(date)" (click)="date && onDateClick(date)"
                (mouseenter)="date && onDateHover(date)">
                {{date ? (date | date:'d') : ''}}
              </div>
            </ng-container>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
